import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container mt-5"
}
const _hoisted_2 = { class: "hotspot__wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onMouseenter", "onMouseleave"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HotspotPopup = _resolveComponent("HotspotPopup")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.titleLn!=0)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString($setup.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      ($setup.featuredImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $setup.featuredImage,
            alt: "",
            class: "hotspot__image"
          }, null, 8 /* PROPS */, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: $setup.fallbackImage,
            alt: "No Image Available",
            class: "hotspot__image"
          }, null, 8 /* PROPS */, _hoisted_4)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotspotItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.Id,
          style: _normalizeStyle(`left: ${item.XCoordinate}%; top: ${item.YCoordinate}%`),
          class: _normalizeClass(["hotspot__hotspot", item.visible ? 'hotspot__hotspot--open' : ''])
        }, [
          _createElementVNode("div", {
            class: "hotspot__icon",
            onMouseenter: $event => ($setup.showItem(item)),
            onMouseleave: $event => ($setup.hideItem(item))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
          _createVNode(_component_HotspotPopup, {
            id: item.Id,
            style: _normalizeStyle(item.visible ? `visibility: visible`: `visibility: hidden`),
            onClose: $event => (_ctx.hotspotToggle(item))
          }, null, 8 /* PROPS */, ["id", "style", "onClose"])
        ], 6 /* CLASS, STYLE */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}